import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { BaseHttpService } from './base-http.service';

import { Observable } from 'rxjs/Observable';
import { ServiceLocator } from '../helpers/service-locator';

import { Lookup, VenueLayout, VenueFacilityType, VenueMeetingItem, RequestVenue, TimeLookup } from '../models';
import { Venue } from '../models/venue';


@Injectable()
export class VenueService extends BaseHttpService<Venue> {
  constructor(private http: HttpClient) {
    super('venues');
  }

  getVenueLayouts(venueId: number): Observable<VenueLayout[]> {
    return this.http
      .get(this.getApiURI() + `/venues/${venueId}/GetVenueLayouts`)
      .catch(this.handleError)
  }

  addVenueLayout(entity: VenueLayout): Observable<VenueLayout> {
    return this.http
      .post(this.getApiURI() + "/venues/CreateVenueLayout", JSON.stringify(entity))
      .catch(this.handleError);
  }

  removeVenueLayout(entity: VenueLayout): Observable<VenueLayout> {
    return this.http
      .post(this.getApiURI() + "/venues/DeleteVenueLayout", JSON.stringify(entity))
      .catch(this.handleError);
  }

  uploadFile(formData: FormData) {
    // this.http is the injected HttpClient
    console.log(formData);
    return this.http
      .post(this.getApiURI() + "/venues/UploadFile", formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .subscribe();
  }

  getFacilityTypes(isChargable: boolean): Observable<VenueFacilityType[]> {

    // Setup log namespace query parameter
    let Params = new HttpParams().set('isChargable', String(isChargable) );

    return this.http
        .get(this.getApiURI() + "/venues/GetFacilityTypes", { params: Params })
        .catch(this.handleError)
     
    
  }

  loadAvailableVenues(entity: VenueMeetingItem): Observable<Venue[]> {
    return this.httpClient
      .post(this.getApiURI() + "/venues/LoadAvailableVenues", JSON.stringify(entity))
      .catch(this.handleError);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/core/data/venue.service.ts